/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1LocationCitiesIdMutationRequest,
  PutApiV1LocationCitiesIdMutationResponse,
  PutApiV1LocationCitiesIdPathParams,
  PutApiV1LocationCitiesId400,
  PutApiV1LocationCitiesId401,
  PutApiV1LocationCitiesId404,
  PutApiV1LocationCitiesId409,
  PutApiV1LocationCitiesId500,
} from "../../types/locationCityController/PutApiV1LocationCitiesId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1LocationCitiesId } from "../../clients/locationCityController/putApiV1LocationCitiesId.ts";

export const putApiV1LocationCitiesIdMutationKey = () =>
  [{ url: "/api/v1/location/cities/:id" }] as const;

export type PutApiV1LocationCitiesIdMutationKey = ReturnType<
  typeof putApiV1LocationCitiesIdMutationKey
>;

export function putApiV1LocationCitiesIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutApiV1LocationCitiesIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putApiV1LocationCitiesIdMutationKey();
  return mutationOptions<
    PutApiV1LocationCitiesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationCitiesId400
      | PutApiV1LocationCitiesId401
      | PutApiV1LocationCitiesId404
      | PutApiV1LocationCitiesId409
      | PutApiV1LocationCitiesId500
    >,
    {
      id: PutApiV1LocationCitiesIdPathParams["id"];
      data?: PutApiV1LocationCitiesIdMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1LocationCitiesId(id, data, config);
    },
  });
}

/**
 * @description Atualiza o código, o nome, o estado e a população de uma cidade. O código permanece único globalmente e o nome único dentro do estado. **(Requer Authorization para autenticação)**
 * @summary Atualizar cidade (Requer Authorization para autenticação)
 * {@link /api/v1/location/cities/:id}
 */
export function usePutApiV1LocationCitiesId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1LocationCitiesIdMutationResponse,
      ResponseErrorConfig<
        | PutApiV1LocationCitiesId400
        | PutApiV1LocationCitiesId401
        | PutApiV1LocationCitiesId404
        | PutApiV1LocationCitiesId409
        | PutApiV1LocationCitiesId500
      >,
      {
        id: PutApiV1LocationCitiesIdPathParams["id"];
        data?: PutApiV1LocationCitiesIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutApiV1LocationCitiesIdMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1LocationCitiesIdMutationKey();

  const baseOptions = putApiV1LocationCitiesIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1LocationCitiesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationCitiesId400
      | PutApiV1LocationCitiesId401
      | PutApiV1LocationCitiesId404
      | PutApiV1LocationCitiesId409
      | PutApiV1LocationCitiesId500
    >,
    {
      id: PutApiV1LocationCitiesIdPathParams["id"];
      data?: PutApiV1LocationCitiesIdMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1LocationCitiesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationCitiesId400
      | PutApiV1LocationCitiesId401
      | PutApiV1LocationCitiesId404
      | PutApiV1LocationCitiesId409
      | PutApiV1LocationCitiesId500
    >,
    {
      id: PutApiV1LocationCitiesIdPathParams["id"];
      data?: PutApiV1LocationCitiesIdMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1LocationCitiesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationCitiesId400
      | PutApiV1LocationCitiesId401
      | PutApiV1LocationCitiesId404
      | PutApiV1LocationCitiesId409
      | PutApiV1LocationCitiesId500
    >,
    {
      id: PutApiV1LocationCitiesIdPathParams["id"];
      data?: PutApiV1LocationCitiesIdMutationRequest;
    },
    TContext
  >;
}
